import { BASE_QUERY_PRO, DEFAULT_SECTION_TOP_COUNT, ruleNewsPlus } from '../shared/configs';

enum SECTION_ENUM {
  BREACHES = 'Data Breaches & Hacks',
  CYBER_RISK = 'Regulation & Cyber Risk',
  CYBER_BUSINESS = 'Cyber Business'
}

const MAIN = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [{ terms: { key: 'SectionType', value: ['pro cyber news'] } }],
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = {
  ...MAIN,
  ...DEFAULT_SECTION_TOP_COUNT
};

const BREACHES = {
  ...BASE_QUERY_PRO,
  query: { ...BASE_QUERY_PRO.query, or: [{ terms: { key: 'TopicCode', value: ['PROCYBERBREACHES', 'PROCYBERNS'] } }] }
};

const CYBER_RISK = {
  ...BASE_QUERY_PRO,
  query: { ...BASE_QUERY_PRO.query, or: [{ terms: { key: 'TopicCode', value: ['PROCYBERREGULATION', 'PROCYBEREX'] } }] }
};

const CYBER_BUSINESS = { ...BASE_QUERY_PRO };

export { MAIN, SECTION_TOP, BREACHES, CYBER_RISK, CYBER_BUSINESS, SECTION_ENUM };
